// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "84c706972bc1";
export const BUILD_VERSION_NUMBER = 69;
